import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MarketingProductInfoComponent } from './marketing-product-info.component';

@NgModule({
    declarations: [MarketingProductInfoComponent],
    imports: [CommonModule, RouterModule],
    exports: [MarketingProductInfoComponent],
})
export class MarketingProductInfoModule {}
